import { formatDate } from '@angular/common';
import { PipeTransform, Pipe } from '@angular/core';
import { BrandLibraryDataService } from '@app/shared/media-library/brand-library.data.service';
import { UIFormatBytesPipe } from '@bannerflow/ui';
import { VideoLibraryAsset } from '@studio/domain/creativeset/video-asset';
import { NodeKind } from '@studio/domain';
import { isHeavyVideo } from '@studio/utils/media';
import { IElement } from '@studio/domain/creativeset/element';

@Pipe({
    name: 'brandLibraryElementTooltip'
})
export class BrandLibraryElementTooltipPipe implements PipeTransform {
    constructor(
        private brandLibraryDataService: BrandLibraryDataService,
        private formatBytes: UIFormatBytesPipe
    ) {}

    transform(element: IElement, nodeKind: NodeKind): string {
        if (nodeKind === NodeKind.Video) {
            return this.getVideoTooltip(element);
        }
        return element.name;
    }

    private getVideoTooltip(element: IElement): string {
        const videoAsset = this.brandLibraryDataService.getAssetByElement<VideoLibraryAsset>(element);

        if (videoAsset) {
            return `Name: ${element.name}<br>
                    Duration: ${
                        videoAsset.durationInMilliseconds
                            ? formatDate(videoAsset.durationInMilliseconds, 'mm:ss', 'en')
                            : ''
                    }<br>
                    Size: ${this.formatBytes.transform(videoAsset.fileSize)}
                    ${
                        isHeavyVideo(videoAsset.fileSize)
                            ? '<span class="heavy-video"> - Heavy video</span>'
                            : ''
                    }`;
        } else {
            return element.name;
        }
    }
}
